import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  DialogTitle,
} from '@mui/material'
import {Icon} from 'components'
import {faXmark} from '@fortawesome/free-solid-svg-icons'

export default function DialogBase(_props) {
  const {
    title = "",
    titleAlignment = "left",
    children = null,
    actionsComponent = null,
    open = false,
    handleClose = () => {console.log('Provide a function to close the dialog')},

  } = _props
  return (
    <Dialog open={open} onClose={handleClose} disableAutoFocus={false}>
      <DialogTitle
        variant="h1"
        textAlign={titleAlignment}
        color="primary"
        className="pt-6 md:whitespace-nowrap"
      >
        {title}
      </DialogTitle>
      <IconButton
        onClick={handleClose}
        color="primary"
        className="absolute right-1 top-2"
      >
        <Icon icon={faXmark}/>
      </IconButton>
      <DialogContent>
        {children}
      </DialogContent>
      <DialogActions>
        {actionsComponent}
      </DialogActions>
    </Dialog>
  )
}
